<template>
  <div class="layout">
    <Layout>
      <Header class="hea">
        <p class="p">数据查询</p>
        <Row class="row">
          <i-col span="18" class="col1">
            查询时间段：
            <RadioGroup v-model="button6" type="button" size="small" @on-change="showTime">
              <Radio label="200天"></Radio>
              <Radio label="今天"></Radio>
              <Radio label="1天"></Radio>
              <Radio label="1星期"></Radio>
              <Radio label="1个月"></Radio>
            </RadioGroup>
            <DatePicker
              type="datetime"
              v-model="start"
              :value="start"
              @on-change="changeStart"
              style="width: 14%;margin-left:5px;"
            ></DatePicker>
            <DatePicker
              type="datetime"
              v-model="end"
              :value="end"
              @on-change="changeEnd"
              style="width: 14%;margin-left:5px;"
            ></DatePicker>
            <Select
              v-model="model89"
              clearable
              style="width:20%;margin-left:5px;"
              placeholder="数据类型"
            >
              <Option
                v-for="item in cityList"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
          </i-col>
          <i-col span="6" class="col1">
            <Button class="btn" @click="serCh">查询</Button>
            <!-- <Button class="btn">报表</Button> -->
            <!-- <Button class="btn">Excel</Button> -->
            <!-- <Button class="btn">删除</Button> -->
          </i-col>
        </Row>
        <p class="p" style="margin-top:10px;">精确查询</p>
        <Row class="row">
          <i-col span="24" class="col1">
            查询时间段：
            <DatePicker
              type="datetime"
              v-model="start1"
              :value="start1"
              @on-change="changeStart1"
              style="width: 14%;margin-left:5px;"
            ></DatePicker>
            <DatePicker
              type="datetime"
              v-model="end1"
              :value="end1"
              @on-change="changeEnd1"
              style="width: 14%;margin: 0 5px 0 5px;"
            ></DatePicker>
            <Select v-model="model8" clearable style="width:10%" placeholder="时段类型" class="shi">
              <Option v-for="item in shiduan" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Select v-model="model9" clearable style="width:10%" placeholder="分" class="shi">
              <Option v-for="item in shijian" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input v-model="value12" placeholder="请输入" clearable style="width: 10%" class="shi" />
            <Button class="btn" @click="sreaCh">查询</Button>
            <Select v-model="modellei" clearable style="width:10%" class="shi">
              <Option
                v-for="item in cityList1"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
            <!-- <Select v-model="model8" clearable style="width:10%" placeholder="累计" class="shi">
              <Option
                v-for="item in cityList"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
            <Select v-model="model8" clearable style="width:10%" placeholder="时段类型" class="shi">
              <Option
                v-for="item in cityList"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>-->
          </i-col>
        </Row>
      </Header>
      <Content :style="{ minHeight: '100%'}">
        <Row class="row2">
          <i-col span="24" class="col2">
            <RadioGroup v-model="border1" @on-change="showwhat">
              <Radio label="初始值" border></Radio>
              <Radio label="2D图" border></Radio>
              <Radio label="全部数据" border></Radio>
              <Radio label="传感器图" border></Radio>
              <Radio label="相对位移" border></Radio>
              <Radio label="管理" border></Radio>
              <Radio label="3D立体图" border></Radio>
            </RadioGroup>
          </i-col>
        </Row>
        <Row class="row2">
          <i-col span="8" class="col3">
            <Card>
              <div>
                <RadioGroup v-model="button4" type="button" size="small" @on-change="show">
                  <Radio label="XZ图"></Radio>
                  <Radio label="YZ图"></Radio>
                </RadioGroup>
                <RadioGroup
                  v-model="chicun"
                  type="button"
                  @on-change="newChi"
                  style="margin-left:5px;"
                >
                  <Radio label="大"></Radio>
                  <Radio label="中"></Radio>
                  <Radio label="原尺寸"></Radio>
                </RadioGroup>
                <Button @click="maxTu" style="float:right;">
                  <Icon type="ios-expand" />
                </Button>
              </div>
              <div style="min-height: 500px;" v-show="showX">
                <div id="main34" style="height:360px;"></div>
              </div>
              <div style="min-height: 500px;" v-show="showY">
                <div id="main33" style="height:360px;width:500px;"></div>
              </div>
              <Spin fix v-show="spinShow" size="large"></Spin>
              <Modal v-model="modal10" footer-hide width="1300">
                <div style="min-height: 800px;">
                  <div id="main344" style="width:1200px;height:800px;"></div>
                </div>
              </Modal>
              <Modal v-model="modal11" footer-hide width="1300">
                <div style="min-height: 800px;">
                  <div id="main333" style="width:1200px;height:800px;"></div>
                </div>
              </Modal>
            </Card>
            
          </i-col>
          <i-col span="8" class="col3">
            <Card style="margin-left:5px;width:100%">
              <div>
                <RadioGroup v-model="button5" type="button" size="small" @on-change="showQ">
                  <Radio label="XZ图"></Radio>
                  <Radio label="YZ图"></Radio>
                </RadioGroup>
                <Button @click="maxTuright" style="float:right;">
                  <Icon type="ios-expand" />
                </Button>
              </div>
              <div style="min-height: 500px;" v-show="showZ">
                <div id="main44" style="height:360px;width:500px;"></div>
              </div>

              <div style="min-height: 500px;" v-show="showYZ">
                <div id="main22" style="height:360px;"></div>
              </div>
              <Spin fix v-show="spinShow1" size="large"></Spin>
              <Modal v-model="modal12" footer-hide width="1300">
                <div style="min-height: 800px;">
                  <div id="main444" style="width:1200px;height:800px;"></div>
                </div>
              </Modal>
              <Modal v-model="modal13" footer-hide width="1300">
                <div style="min-height: 800px;">
                  <div id="main222" style="width:1200px;height:800px;"></div>
                </div>
              </Modal>
            </Card>
                
          </i-col>
          
          <i-col span="8" class="col3">
            <Card style="margin-left:5px;">
              <div>
                <Button @click="handleSelectAll" style="width:100%;margin-bottom:10px;">绘图</Button>
              </div>
              <div style="min-height: 200px;height:430px;overflow-y:auto;">
                <Table
                  ref="selection"
                  :columns="columns4"
                  :data="data1"
                  @on-selection-change="changeSelection"
                ></Table>
                <Page
                  class="pageBox"
                  style="margin-top: 30px;text-align: center;padding:0 20px 0 20px;"
                  :total="pageTotal"
                  :current="page"
                  :page-size="limit"
                  @on-change="changePage"
                />
              </div>
            </Card>
          </i-col>
        </Row>
        <Row>
          <Table border :columns="columns12" :data="data6" style="margin-top:60px;">
                    <template slot-scope="{ row }" slot="name">
                        <strong>{{ row.name }}</strong>
                    </template>
                    <template slot-scope=" { row }" slot="action">
                        <Button type="primary" size="small" style="margin-right: 5px" @click="show1(row)">移除对比</Button>
                    </template>
            </Table>
        </Row>
      </Content>
    </Layout>
  </div>
</template>
<script>
import echarts from "echarts";
import api from "@/api/aipause";
export default {
  data() {
    return {
      columns12: [
        {
            title: '需要绘图的时间段',
            slot: 'name'
        },
        {
            title: '操作',
            slot: 'action',
            width: 150,
            align: 'center'
        }
      ],
      data6: [],
      pageTotal: "", // 数据总条数
      page: 1, // 页码
      limit: 20, // 每页显示条数
      //单选
      button6: "",
      border: "初始值",
      button4: "XZ图",
      button5: "YZ图",
      border1: "2D图",
      //开始时间
      start: "",
      start1: "",
      end: "",
      end1: "",
      spinShow: true,
      spinShow1: true,
      //下拉列表
      cityList: [
        {
          value: "real",
          label: "实时值"
        },
        {
          value: "avg",
          label: "日平均值"
        },
        {
          value: "max",
          label: "日最大值"
        },
        {
          value: "min",
          label: "日最小值"
        }
      ],
      cityList1: [
        {
          value: "real",
          label: "累计"
        },
        {
          value: "avg",
          label: "简单累计"
        },
        {
          value: "max",
          label: "简单位移"
        }
      ],
      modellei: "real",
      shiduan: [
        {
          value: "时间段",
          label: "时间段"
        },
        {
          value: "指定值",
          label: "指定值"
        }
      ],
      shijian: [
        {
          value: "月",
          label: "月"
        },
        {
          value: "日",
          label: "日"
        },
        {
          value: "时",
          label: "时"
        },
        {
          value: "分",
          label: "分"
        }
      ],
      model8: "",
      model89: "",
      model88: true,
      model9: "",
      modal10: false,
      modal11: false,
      modal12: false,
      modal13: false,
      //输入框
      value14: "",
      value12: "",
      //右侧边
      columns4: [
        {
          type: "selection",
          width: 33,
          align: "center"
        },
        {
          title: "时间段",
          // width: 10,
          key: "name"
        },
        {
          title: "操作",
          key: "action",
          // width: 180,
          align: "center",
          render: (h, params) => {
            return h('div', [
                h('Button', {
                    props: {
                      type: "primary",
                      size: "small",
                      disabled: this.model88
                    },
                    style: {
                        marginRight: '5px'
                    },
                    on: {
                        click: () => {
                            this.bianZhi(params.row);
                        }
                    }
                }, '初始值'),
                h('Button', {
                    props: {
                        type: 'primary',
                        size: 'small'
                    },
                    on: {
                        click: () => {
                            this.shoer(params.row)
                        }
                    }
                }, '加入对比')
            ]);
          }
        }
      ],
      data1: [],
      shuju: [],
      shuju2: [],
      newDatY: [],
      newDatX: [],
      newDatYZ: [],
      newDatXZ: [],
      showX: true,
      showY: false,
      showZ: false,
      showYZ: true,
      i: 0,
      time: "",
      color: "",
      leftWidth: "",
      leftNu: "",
      allData: {},
      chicun: "",
      maxX: "",
      maxY: "",
      maxZ: "",
      maxZ1: "",
      zData: [],
      xData: [],
      yData: [],
      unit: "",
      myChart1: "",
      myChart3: "",
      myChart2: "",
      myChart4: ""
    };
  },
  methods: {
    //加入对比
    shoer(row){
     
      this.data6.push({
        name:row.name
      })
    },
    show1(row){
      for(let i = 0 ; i < this.data6.length ;i++){
        if(row.name == this.data6[i].name){
          this.data6.splice(i,1);
        }
      }
      for(let i = 0 ; i < this.time.length ;i++){
        if(row.name == this.time[i].name){
          this.time.splice(i,1);
        }
      }
    },
    //标签跳转
    showwhat($event) {
      //
      if ($event == "2D图") {
        this.$router.push({
          name: "2D_figure"
        });
      }
      if ($event == "初始值") {
        this.$router.push({
          path: `/engineering/3D_diagram/${localStorage.getItem("deviceId")}`
        });
      }
      if ($event == "全部数据") {
        this.$router.push({
          name: "allData"
        });
      }
      if ($event == "传感器图") {
        this.$router.push({
          name: "sensor_Figure"
        });
      }
      if ($event == "相对位移") {
        this.$router.push({
          name: "relative_Displacement"
        });
      }
      if ($event == "管理") {
        this.$router.push({
          name: "management"
        });
      }
      if ($event == "3D立体图") {
        this.$router.push({
          name: "3D_Stereogram"
        });
      }
    },
    bianZhi(params) {
      api("post", "setOriginal", {
        dirId: localStorage.getItem("deviceId"),
        created: params.name
      }).then(res => {
        let data = res.data;
        if (data.code === 0) {
          this.$Message.success("初始值设置成功");
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    maxTu() {
      //
      if (this.button4 == "XZ图") {
        this.modal10 = true;
        setTimeout(() => {
          // this.c = {
          //   width:"" + document.body.clientWidth - 100 + ""+"px",
          //   height:"" + document.body.clientHeight - 200 + ""+"px"
          // }
          this.leftXz344(this.newDatX, this.unit);
        }, 500);
      }
      if (this.button4 == "YZ图") {
        this.modal11 = true;
        setTimeout(() => {
          // this.c = {
          //   width:"" + document.body.clientWidth - 100 + ""+"px",
          //   height:"" + document.body.clientHeight - 200 + ""+"px"
          // }
          this.leftYz333(this.newDatY, this.unit);
        }, 500);
      }
    },
    maxTuright() {
      if (this.button5 == "XZ图") {
        this.modal12 = true;
        setTimeout(() => {
          // this.c = {
          //   width:"" + document.body.clientWidth - 100 + ""+"px",
          //   height:"" + document.body.clientHeight - 200 + ""+"px"
          // }
          this.rightYz444(this.newDatX, this.unit);
        }, 500);
      }
      if (this.button5 == "YZ图") {
        this.modal13 = true;
        setTimeout(() => {
          // this.c = {
          //   width:"" + document.body.clientWidth - 100 + ""+"px",
          //   height:"" + document.body.clientHeight - 200 + ""+"px"
          // }
          this.rightXz222(this.newDatY, this.unit);
        }, 500);
      }
    },
    //选择时间
    showTime($event) {
      if ($event == "1天") {
        localStorage.setItem("button6" , $event)
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000); //前一天
        this.changeStart(this.switchTimeFormat(preDate));
        this.changeEnd(this.switchTimeFormat(new Date()));
      }
      if ($event == "1星期") {
        localStorage.setItem("button6" , $event)
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 7 * 24 * 3600 * 1000); //前一天
        this.changeStart(this.switchTimeFormat(preDate));
        this.changeEnd(this.switchTimeFormat(new Date()));
      }
      if ($event == "1个月") {
        localStorage.setItem("button6" , $event)
        let curDate = new Date();
        let preDate = new Date(curDate.setMonth(curDate.getMonth() - 1)); //前一天
        this.changeStart(this.switchTimeFormat(preDate));
        this.changeEnd(this.switchTimeFormat(new Date()));
      }
      if ($event == "200天") {
        localStorage.setItem("button6" , $event)
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 200 * 24 * 3600 * 1000); //前一天
        this.changeStart(this.switchTimeFormat(preDate));
        this.changeEnd(this.switchTimeFormat(new Date()));
      }
      if ($event == "今天") {
        localStorage.setItem("button6" , $event)
        let start = new Date(
          new Date(new Date().toLocaleDateString()).getTime()
        );
        let end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        );
        this.changeStart(this.switchTimeFormat(start));
        this.changeEnd(this.switchTimeFormat(end));
      }
      //
    },
    switchTimeFormat(time) {
      const dateTime = new Date(time);
      const year = dateTime.getFullYear();
      const month = dateTime.getMonth() + 1;
      const date = dateTime.getDate();
      const hour = dateTime.getHours();
      const minute = dateTime.getMinutes();
      const second = dateTime.getSeconds();
      return `${year}-${this.addZero(month)}-${this.addZero(
        date
      )} ${this.addZero(hour)}:${this.addZero(minute)}:${this.addZero(second)}`;
    },
    addZero(v) {
      return v < 10 ? "0" + v : v;
    },
    show($event) {
      this.leftNu = $event;
      if ($event == "YZ图") {
        // alert(1)

        // card1[0].className="big";
        // window.addEventListener("resize", () => { myChart4.resize();});
        // var card1 = document.getElementById('card1').setAttribute('class','big');
        // $('#demo').addClass('big')
        this.showX = false;
        this.showY = true;
      }
      if ($event == "XZ图") {
        // alert(1)
        this.showX = true;
        this.showY = false;
      }
    },
    showQ($event) {
      if ($event == "XZ图") {
        // alert(1)
        this.showYZ = false;
        this.showZ = true;
      }
      if ($event == "YZ图") {
        // alert(1)
        this.showYZ = true;
        this.showZ = false;
      }
    },
    changePage(val) {
      this.page = val;
    },
    serCh() {
      // this.start = this.switchTimeFormat(localStorage.getItem("start1"));
      // this.end = this.switchTimeFormat(localStorage.getItem("end1"));
      this.spinShow = true;
      this.spinShow1 = true;
      this.data1 = [];
      this.i = 0;
      this.shuju = [];
      this.shuju2 = [];
      this.newDatY = [];
      this.newDatX = [];
      this.end = this.switchTimeFormat(this.end);
      this.start = this.switchTimeFormat(this.start);
      localStorage.setItem("start1" , this.start)
      localStorage.setItem("end1" , this.end)
      if (this.start == "" && this.end == "") {
        if (this.model89 !== "") {
          if (this.model89 == "real") {
            this.allData = {
              dirId: localStorage.getItem("deviceId")
              // start: "" + this.start + "",
              // end: "" + this.end + "",
              // statistic: this.model89
            };
          } else if (this.model89 !== "real") {
            this.allData = {
              dirId: localStorage.getItem("deviceId"),
              // start: "" + this.start + "",
              // end: "" + this.end + "",
              group: "day"
            };
          } else if (this.model89 == "") {
            this.getMenu();
          }
        }
      } else if (!this.start) {
        return this.$Message.error("请选择开始时间");
      } else if (!this.end) {
        return this.$Message.error("请选择结束时间");
      } else if (this.start !== "" && this.end !== "") {
        if (this.model89 !== "") {
          if (this.model89 == "real") {
            this.allData = {
              dirId: localStorage.getItem("deviceId"),
              start: "" + this.start + "",
              end: "" + this.end + ""
              // statistic: this.model89
            };
          } else {
            this.allData = {
              dirId: localStorage.getItem("deviceId"),
              start: "" + this.start + "",
              end: "" + this.end + "",
              group: "day"
            };
          }
        }
      }
      this.$Message.loading({
        content: "正在获取数据请稍候..",
        duration: 2
      });
      api("post", "queryNodeDateList", {
        // dirId: localStorage.getItem("deviceId"),
        // start: "" + this.start + "",
        // end: "" + this.end + "",
        page: this.page,
        limit: "20",
        order: "desc",
        sidx: "created",
        ...this.allData
      }).then(res => {
        let data = res.data;
        //
        if (data.code === 0) {
          // this.data1.push data.incline
          if (data.incline.list.length == 0) {
            this.spinShow = false;
            this.spinShow1 = false;
            this.$Message.success("暂无数据");
            this.rightXz();
            this.leftYz();
            this.leftXz();
            this.rightYz();
            return;
          } else {
            this.pageTotal = data.incline.totalCount;
            this.$Message.success("搜索成功");
            for (let i = 0; i < data.incline.list.length; i++) {
              this.data1.push({
                name: data.incline.list[i]
              });
            }
            if (this.model89 == "real") {
              this.model88 = false;
            } else {
              this.model88 = true;
            }
            setTimeout(() => {
              this.$refs.selection.objData[0]._isChecked = true;
              let zhi = this.$refs.selection.objData[0];
              let res = [];
              res.push({
                zhi
              });
              this.time = res;
             
              api("post", "queryPage", {
                dirId: localStorage.getItem("deviceId"),
                time: this.time[0].zhi.name,
                coordiType: "2D",
                statistic: this.model89
              }).then(res => {
                let data = res.data;
                if (data.code === 0) {
                  this.shuju = [];
                  this.shuju2 = [];
                  this.shuju.push([0, 0, 0]);
                  this.shuju2.push([0, 0, 0]);
                  for (let i = 0; i < data.YZ.length; i++) {
                    this.shuju.push([data.YZ[i].y, data.YZ[i].z]);
                    this.yData.push(data.YZ[i].y);
                    this.zData.push(data.YZ[i].z);
                  }
                  for (let ii = 0; ii < data.XZ.length; ii++) {
                    this.shuju2.push([data.XZ[ii].x, data.XZ[ii].z]);
                    this.xData.push(data.XZ[ii].x);
                  }

                  //
                  this.newDatY.push({
                    name: this.time[this.i].name,
                    data: this.shuju,
                    symbolSize: 6,
                    type: "line"
                  });
                  this.newDatX.push({
                    name: this.time[this.i].name,
                    data: this.shuju2,
                    symbolSize: 6,
                    type: "line"
                  });
                  this.unit = data.unit;
                  this.chicun = "大";
                  let allDataMin = []
                  allDataMin=[
                    0,
                    ...this.xData,
                    ...this.zData,
                    ...this.yData
                  ]
                 
                  this.maxX = Math.abs(this.getMax(allDataMin)*3);
                  this.maxY = Math.abs(this.getMin(allDataMin)*3);
                  // this.maxZ = this.getMax(this.zData) * 2;
                  // this.maxZ = this.getMax(this.zData) * 2;
                  if (this.newDatY != [] && this.newDatX != []) {
                    this.spinShow1 = false;
                    this.spinShow = false;
                  }
                  this.rightXz(this.newDatY, this.unit);
                  this.leftYz(this.newDatY, this.unit);
                  this.leftXz(this.newDatX, this.unit);
                  this.rightYz(this.newDatX, this.unit);
                  // this.i++;
                  // if (this.i < this.time.length) {
                  //   this.handleSelectAll();
                  // }
                } else {
                  this.spinShow1 = false;
                  this.spinShow = false;
                  this.$Message.error(data.msg);
                }
              });
            }, 300);
          }
        } else {
          this.spinShow1 = false;
          this.spinShow = false;
          this.$Message.error(data.msg);
        }
      });
    },
    //精确查询
    sreaCh() {
      if (this.start1 !== "" || this.end1 !== "") {
        if (!this.model8) return this.$Message.error("请选择时段类型");
        if (this.model8 == "时间段") {
          localStorage.setItem("start", this.start1);
          localStorage.setItem("end", this.end1);
          this.$router.push({
            path: "/engineering/allData",
            query: {
              name: "1",
              shiduan: this.model8,
              shijian: this.model9,
              jinTime: this.value12
            }
          });
        } else if (this.model8 == "指定值") {
          if (this.start1 !== "") {
            localStorage.setItem("start", this.start1);
            // localStorage.setItem("end", this.end1);
            this.$router.push({
              path: "/engineering/allData",
              query: {
                name: "1",
                shiduan: this.model8,
                shijian: this.model9,
                jinTime: this.value12
              }
            });
          } else if (this.end1 !== "") {
            this.$Message.error("指定时间只能选择开始时间，不能选择结束时间");
            // localStorage.setItem("start", this.start1);
            // // localStorage.setItem("end", this.end1);
            // this.$router.push({
            //   path: "/engineering/allData",
            //   query: {
            //     name: "1",
            //     shiduan: this.model8,
            //     shijian: this.model9,
            //     jinTime: this.value12
            //   }
            // });
          }
        }
      } else {
        if (!this.model8) return this.$Message.error("请选择时段类型");
        // this.getMenu();
        localStorage.setItem("start", "");
        localStorage.setItem("end", "");
        this.$router.push({
          path: "/engineering/allData",
          query: {
            name: "1",
            shiduan: this.model8,
            shijian: this.model9,
            jinTime: this.value12
          }
        });
      }
      // if(this.start1 == "" || this.end1 == ""){
      //   if (!this.model8) return this.$Message.error("请选择时段类型");
      // }else {
      //   this.getMenu();
      // }
    },
    changeStart1(data) {
      this.start1 = data;
    },
    //结束时间
    changeEnd1(data) {
      this.end1 = data;
    },
    //开始时间
    changeStart(data) {
      this.start = data;
      localStorage.setItem("start1" , this.start)
    },
    //结束时间
    changeEnd(data) {
      this.end = data;
      localStorage.setItem("end1" , this.end)
    },
    //全选
    handleSelectAll(status) {
     
      this.i = 0;
      this.newDatY = [];
      this.newDatX = [];
      this.xData = [];
      this.yData = [];
      this.newData = []
      this.newData = this.data6
      this.newData.map((item,index)=>{
        this.time.push({name:item.name})
      })
      let hash = {};
        this.time = this.time.reduce(function(item, next) {
        hash[next.name] ? '' : hash[next.name] = true && item.push(next);
        return item
      }, [])
     
      if (this.time.length === 0) {
        this.$Message.error("请选择时间段");
      } else {
        // this.getRandomColor();return;
        this.getDat();
      }
    },
    leftXz(e, unit) {
      //console.error(e)
      var myChart1 = echarts.init(document.getElementById("main34"));
      this.myChart1 = myChart1;
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        grid: {
          left: '18%'
        },
        xAxis: {
          name: "X",
          type: "value",
          min: -this.maxY,
          max: this.maxX
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          max: -this.maxY,
          min: this.maxX
        },
        series: e
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart1.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart1.resize();
      });
    },
    leftXz344(e, unit) {
      var myChart1 = echarts.init(document.getElementById("main344"));
      this.myChart1 = myChart1;
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        grid: {
          left: '18%'
        },
        xAxis: {
          name: "X",
          type: "value",
          min: -this.maxY,
          max: this.maxX
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          max: -this.maxY,
          min: this.maxX
        },
        series: e
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart1.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart1.resize();
      });
    },
    rightXz(e, unit) {
      var myChart3 = echarts.init(document.getElementById("main22"));
      this.myChart3 = myChart3;
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        grid: {
          left: '18%'
        },
        xAxis: {
          name: "Y",
          type: "value",
          min: -this.maxY,
          max: this.maxX
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          max: -this.maxY,
          min: this.maxX
        },

        series: e
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart3.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart3.resize();
      });
    },
    rightXz222(e, unit) {
      var myChart3 = echarts.init(document.getElementById("main222"));
      this.myChart3 = myChart3;
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        grid: {
          left: '18%'
        },
        xAxis: {
          name: "Y",
          type: "value",
          min: -this.maxY,
          max: this.maxX
        },
        yAxis: {
          name: "Z 单位" + unit,
          max: -this.maxY,
          min: this.maxX
        },

        series: e
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart3.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart3.resize();
      });
    },
    leftYz(e, unit) {
      var myChart4 = echarts.init(document.getElementById("main33"));
      this.myChart4 = myChart4;
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        grid: {
          left: '18%'
        },
        xAxis: {
          name: "Y",
          type: "value",
          min: -this.maxY,
          max: this.maxX
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          max: -this.maxY,
          min: this.maxX
        },

        series: e
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart4.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart4.resize();
      });
    },
    leftYz333(e, unit) {
      var myChart4 = echarts.init(document.getElementById("main333"));
      this.myChart4 = myChart4;
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        grid: {
          left: '18%'
        },
        xAxis: {
          name: "Y",
          type: "value",
          min: -this.maxY,
          max: this.maxX
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          max: -this.maxY,
          min: this.maxX
        },

        series: e
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart4.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart4.resize();
      });
    },
    rightYz(e, unit) {
      var myChart2 = echarts.init(document.getElementById("main44"));
      this.myChart2 = myChart2;
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        grid: {
          left: '18%'
        },
        xAxis: {
          name: "X",
          type: "value",
          min: -this.maxY,
          max: this.maxX
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          max: -this.maxY,
          min: this.maxX
        },
        series: e
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart2.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart2.resize();
      });
      // window.onresize = myChart.resize;
    },
    rightYz444(e, unit) {
      var myChart2 = echarts.init(document.getElementById("main444"));
      this.myChart2 = myChart2;
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        grid: {
          left: '18%'
        },
        xAxis: {
          name: "X",
          type: "value",
          min: -this.maxY,
          max: this.maxX
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          max: -this.maxY,
          min: this.maxX
        },
        series: e
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart2.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart2.resize();
      });
      // window.onresize = myChart.resize;
    },
    getMenu() {
      this.start = this.switchTimeFormat(localStorage.getItem("start1"));
      this.end = this.switchTimeFormat(localStorage.getItem("end1"));
      if(localStorage.getItem("start1") == null || localStorage.getItem("end1") == null || localStorage.getItem("start1") == "" || localStorage.getItem("end1") == ""){
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000); //前一天
        this.button6 = "1天";
        localStorage.setItem("button6" , "1天")
        //
        this.changeStart(this.switchTimeFormat(preDate));
        this.changeEnd(this.switchTimeFormat(new Date()));
      }else{
        this.changeStart(localStorage.getItem("start1"));
        this.changeEnd(localStorage.getItem("end1"));
      }
      this.$Message.loading({
        content: "正在获取数据请稍候..",
        duration: 2
      });
      this.model89 =
        localStorage.getItem("dataType") == null
          ? "avg"
          : localStorage.getItem("dataType");
          if (this.model89 == "real") {
              this.model88 = false;
            } else {
              this.model88 = true;
            }
      api("post", "queryNodeDateList", {
        dirId: localStorage.getItem("deviceId"),
        start: "" + this.start + "",
        end: "" + this.end + "",
        order: "desc",
        sidx: "created",
        limit:"20",
        page: this.page,
        group: this.model89
      }).then(res => {
        let data = res.data;
        //
        if (data.code === 0) {
          // this.data1.push data.incline
          if(data.incline.list.length == 0){
            this.$Message.error("该时间段没有数据")
            this.spinShow = false;
            this.spinShow1 = false;
          }else{
            for (let i = 0; i < data.incline.list.length; i++) {
              this.data1.push({
                name: data.incline.list[i]
              });
            }
            // this.start = this.data1[0].name
            // this.end = this.data1[this.data1.length-1].name
            this.pageTotal = data.incline.totalCount;
            
            //
            setTimeout(() => {
              this.$refs.selection.objData[0]._isChecked = true;
              let res = [];
              res.push({
                name: this.$refs.selection.objData[0].name
              });
              this.time = res;
              this.handleSelectAll();
            }, 300);
          }
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    getTime() {
      api("post", "queryPage", {
        dirId: localStorage.getItem("deviceId"),
        coordiType: "2D"
      }).then(res => {
        let data = res.data;
        //
        if (data.code === 0) {
          for (let i = 0; i < data.YZ.length; i++) {
            this.shuju.push([data.YZ[i].y, data.YZ[i].z]);
          }
          for (let i = 0; i < data.XZ.length; i++) {
            this.shuju2.push([
              data.XZ[i].x,
              data.XZ[i].z
              // data.incline[i].depth
            ]);
          }
          this.newDatYZ.push({
            data: this.shuju,
            color: "green",
            symbolSize: 6,
            type: "line"
            // lineStyle: {
            //   width: 4
            // }
          });
          this.newDatXZ.push({
            data: this.shuju2,
            color: "red",
            symbolSize: 6,
            type: "line"
            // lineStyle: {
            //   width: 4
            // }
          });
          //
          this.as(this.newDatYZ);
          this.aq(this.newDatYZ);
          this.asd(this.newDatXZ);
          this.ase(this.newDatXZ);
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    getMax(abc) {
      // 1.要深拷贝数组
      abc = abc.slice(0);
      // 2.排序（升序第一个值是最小值，降序第一个值是最大值）
      abc.sort(function(a, b) {
        return b - a;
      });
      // 3.返回第一个值
      return abc[0];
    },
    getMin(abc) {
      // 1.要深拷贝数组
      abc = abc.slice(0);
      // 2.排序（升序第一个值是最小值，降序第一个值是最大值）
      abc.sort(function(a, b) {
        return a - b;
      });
      // 3.返回第一个值
      return abc[0];
    },
    getDat() {
      this.spinShow = true;
      this.spinShow1 = true;
      api("post", "queryPage", {
        dirId: localStorage.getItem("deviceId"),
        time: this.time[this.i].name,
        coordiType: "2D",
        statistic: this.model89
      }).then(res => {
        let data = res.data;
        if (data.code === 0) {
          this.shuju = [];
          this.shuju2 = [];
          this.shuju.push([0, 0, 0]);
          this.shuju2.push([0, 0, 0]);
          // this.unit = "";
          for (let i = 0; i < data.YZ.length; i++) {
            this.shuju.push([data.YZ[i].y, data.YZ[i].z]);
            this.yData.push(data.YZ[i].y);
            this.zData.push(data.YZ[i].z);
          }
          for (let ii = 0; ii < data.XZ.length; ii++) {
            this.shuju2.push([data.XZ[ii].x, data.XZ[ii].z]);
            this.xData.push(data.XZ[ii].x);
          }

         
          this.newDatY.push({
            name: this.time[this.i].name,
            data: this.shuju,
            symbolSize: 6,
            type: "line"
          });
          this.newDatX.push({
            name: this.time[this.i].name,
            data: this.shuju2,
            symbolSize: 6,
            type: "line"
          });
          this.chicun = "大";
          let allDataMin = []
          allDataMin=[
            0,
            ...this.xData,
            ...this.zData,
            ...this.yData
          ]
         
          this.maxX = Math.abs(this.getMax(allDataMin)*3);
          this.maxY = Math.abs(this.getMin(allDataMin)*3);
          this.unit = data.unit;
          this.rightXz(this.newDatY, this.unit);
          this.rightXz222(this.newDatY, this.unit);
          this.leftYz(this.newDatY, this.unit);
          this.leftXz(this.newDatX, this.unit);
          this.leftYz333(this.newDatY, this.unit);
          this.leftXz344(this.newDatX, this.unit);
          this.rightYz(this.newDatX, this.unit);
          this.rightYz444(this.newDatX, this.unit);

         
          this.i++;
          if (this.i < this.time.length) {
            this.getDat();
          }
          if (this.i == this.time.length) {
            this.spinShow = false;
            this.spinShow1 = false;
          }
        } else {
          this.spinShow1 = false;
          this.spinShow = false;
          this.$Message.error(data.msg);
        }
      });
    },
    newChi() {
      if (this.chicun == "大") {
        let allDataMin = []
          allDataMin=[
            0,
            ...this.xData,
            ...this.zData,
            ...this.yData
          ]
        this.maxX = Math.abs(this.getMax(allDataMin)*3);
        this.maxY = Math.abs(this.getMin(allDataMin)*3);
        // this.maxZ = this.getMax(this.zData) * 1.5;
      }
      if (this.chicun == "中") {
        let allDataMin = []
          allDataMin=[
            0,
            ...this.xData,
            ...this.zData,
            ...this.yData
          ]
        this.maxX = Math.abs(this.getMax(allDataMin)*2);
        this.maxY = Math.abs(this.getMin(allDataMin)*2);
      }
      if (this.chicun == "原尺寸") {
        let asd = [];
        this.xData.map(item => {
          asd.push(Math.abs(item));
        });
        let allDataMin = []
          allDataMin=[
            0,
            ...this.xData,
            ...this.zData,
            ...this.yData
          ]
        this.maxX = Math.abs(this.getMax(allDataMin));
        this.maxY = Math.abs(this.getMin(allDataMin));
      }
      this.rightXz(this.newDatY, this.unit);
      this.rightXz222(this.newDatY, this.unit);
      this.leftYz(this.newDatY, this.unit);
      this.leftXz(this.newDatX, this.unit);
      this.leftYz333(this.newDatY, this.unit);
      this.leftXz344(this.newDatX, this.unit);
      this.rightYz(this.newDatX, this.unit);
      this.rightYz444(this.newDatX, this.unit);
    },
    // 复选框选中内容
    changeSelection(selection) {
      this.time = selection;
    }
  },
  mounted() {
    this.getMenu();
    this.button6 = localStorage.getItem("button6")
    this.spinShow = true;
    this.spinShow1 = true;
    // this.getTime();
  },
  beforeDestroy() {
    this.myChart1.clear();
    this.myChart3.clear();
    this.myChart2.clear();
    this.myChart4.clear();
  },
  watch: {
    time(val, newval) {
      this.i = 0;
      this.newDatY = [];
      this.newDatX = [];
      this.xData = [];
      this.yData = [];
      this.zData = [];
    },
    model89() {
      localStorage.setItem("dataType", this.model89);
    },
    page: {
      handler() {
        this.spinShow = true;
        this.spinShow1 = true;
        this.data1 = [];
        this.i = 0;
        this.shuju = [];
        this.shuju2 = [];
        this.newDatY = [];
        this.newDatX = [];
        this.end = this.switchTimeFormat(this.end);
        this.start = this.switchTimeFormat(this.start);
        if (this.start == "" && this.end == "") {
          if (this.model89 !== "") {
            if (this.model89 == "real") {
              this.allData = {
                dirId: localStorage.getItem("deviceId")
                // start: "" + this.start + "",
                // end: "" + this.end + "",
                // statistic: this.model89
              };
            } else if (this.model89 !== "real") {
              this.allData = {
                dirId: localStorage.getItem("deviceId"),
                // start: "" + this.start + "",
                // end: "" + this.end + "",
                group: "day"
              };
            } else if (this.model89 == "") {
              this.getMenu();
            }
          }
        } else if (!this.start) {
          return this.$Message.error("请选择开始时间");
        } else if (!this.end) {
          return this.$Message.error("请选择结束时间");
        } else if (this.start !== "" && this.end !== "") {
          if (this.model89 !== "") {
            if (this.model89 == "real") {
              this.allData = {
                dirId: localStorage.getItem("deviceId"),
                start: "" + this.start + "",
                end: "" + this.end + ""
                // statistic: this.model89
              };
            } else {
              this.allData = {
                dirId: localStorage.getItem("deviceId"),
                start: "" + this.start + "",
                end: "" + this.end + "",
                group: "day"
              };
            }
          }
        }
        this.$Message.loading({
          content: "正在获取数据请稍候..",
          duration: 2
        });
        api("post", "queryNodeDateList", {
          // dirId: localStorage.getItem("deviceId"),
          // start: "" + this.start + "",
          // end: "" + this.end + "",
          page: this.page,
          limit: "20",
          ...this.allData
        }).then(res => {
          let data = res.data;
          //
          if (data.code === 0) {
            // this.data1.push data.incline
            if (data.incline.list.length == 0) {
              this.spinShow = false;
              this.spinShow1 = false;
              this.$Message.success("暂无数据");
              this.rightXz();
              this.leftYz();
              this.leftXz();
              this.rightYz();
              return;
            } else {
              this.pageTotal = data.incline.totalCount;
              this.$Message.success("搜索成功");
              for (let i = 0; i < data.incline.list.length; i++) {
                this.data1.push({
                  name: data.incline.list[i]
                });
              }
              if (this.model89 == "real") {
                this.model88 = false;
              } else {
                this.model88 = true;
              }
              setTimeout(() => {
                this.$refs.selection.objData[0]._isChecked = true;
                let zhi = this.$refs.selection.objData[0];
                let res = [];
                res.push({
                  zhi
                });
                this.time = res;
               
                api("post", "queryPage", {
                  dirId: localStorage.getItem("deviceId"),
                  time: this.time[0].zhi.name,
                  coordiType: "2D",
                  statistic: this.model89
                }).then(res => {
                  let data = res.data;
                  if (data.code === 0) {
                    this.shuju = [];
                    this.shuju2 = [];
                    this.shuju.push([0, 0, 0]);
                    this.shuju2.push([0, 0, 0]);
                    for (let i = 0; i < data.YZ.length; i++) {
                      this.shuju.push([data.YZ[i].y, data.YZ[i].z]);
                      this.yData.push(data.YZ[i].y);
                      this.zData.push(data.YZ[i].z);
                    }
                    for (let ii = 0; ii < data.XZ.length; ii++) {
                      this.shuju2.push([data.XZ[ii].x, data.XZ[ii].z]);
                      this.xData.push(data.XZ[ii].x);
                    }

                    //
                    this.newDatY.push({
                      name: this.time[this.i].name,
                      data: this.shuju,
                      symbolSize: 6,
                      type: "line"
                    });
                    this.newDatX.push({
                      name: this.time[this.i].name,
                      data: this.shuju2,
                      symbolSize: 6,
                      type: "line"
                    });
                    this.unit = data.unit;
                    this.chicun = "大";
                    let asd = [];
                    this.xData.map(item => {
                      asd.push(Math.abs(item));
                    });
                    this.maxX = Math.abs(this.getMax(asd)) * 50;
                    this.maxY = this.getMax(this.yData) * 500;
                    // this.maxZ = this.getMax(this.zData) * 2;
                    if (this.newDatY != [] && this.newDatX != []) {
                      this.spinShow1 = false;
                      this.spinShow = false;
                    }
                    this.rightXz(this.newDatY, this.unit);
                    this.leftYz(this.newDatY, this.unit);
                    this.leftXz(this.newDatX, this.unit);
                    this.rightYz(this.newDatX, this.unit);
                    // this.i++;
                    // if (this.i < this.time.length) {
                    //   this.handleSelectAll();
                    // }
                  } else {
                    this.spinShow1 = false;
                    this.spinShow = false;
                    this.$Message.error(data.msg);
                  }
                });
              }, 300);
            }
          } else {
            this.spinShow1 = false;
            this.spinShow = false;
            this.$Message.error(data.msg);
          }
        });
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.layout {
  overflow: hidden;
  height: 100%;
}
.row2 {
  margin-top: 10px;
}
.row {
  color: #000;
  background-color: darkgrey;
  width: 100%;
}

.row1 {
  /* margin-top: 10px; */
  width: 100%;
  color: #000;
  background-color: darkgrey;
}
.hea {
  background-color: #fff;
  height: 100%;
  padding: 0;
}
.p {
  width: 60px;
  height: 18px;
  line-height: 19px;
  background-color: darkgrey;
  padding-left: 2px;
}
.btn {
  margin-right: 5px;
}
.xia {
  height: 50px;
  line-height: 50px;
  /* margin-left: 10px; */
}
.col1 {
  /* height:50px; */
  line-height: 50px;
}
.shi {
  margin-right: 5px;
}
.col2 {
  background-color: darkgrey;
  height: 50px;
  line-height: 50px;
  padding-left: 10px;
}
content {
  height: 100%;
}
.col3 {
  height: 500px;
}
</style>